
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import MRedemption from '../MRedemption.vue';
import MEligibleRewards from './MEligibleRewards.vue';

@Options({
  components: {
    MRedemption,
    MEligibleRewards
  }
})
export default class MAddToCartPopup extends mixins(CartWidgetMixin) {
  show = false;

  get redemptionSuccessLabel() {
    return this.redemptionSuccessText ? this.redemptionSuccessText : 'Redemption Submitted';
  }

  close() {
    this.$emit('close');
  }

  async mounted() {
    this.$nextTick(() => {
      document.body.appendChild(this.$el);

      setTimeout(() => {
        this.show = true;

        this.$nextTick(() => {
          document
            .querySelector('.m-add-to-cart-popup-container')
            ?.addEventListener('click', () => {
              this.close();
            });
          document.querySelector('.m-add-to-cart-popup')?.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        });
      }, 250);
    });
  }

  beforeUnmount(): void {
    document.body.removeChild(this.$el);
  }
}
